import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Scissors } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/nrmTFaPw3fdgTnDyCxNNzV/Captura_de_pantalla_2026-05-26_231223.png';
export function IntroAnimation({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [isVisible, setIsVisible] = useState(true);
  const [reducedMotion, setReducedMotion] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mq.matches);
    const hasSeenIntro = sessionStorage.getItem('mp_intro_seen');
    if (hasSeenIntro) {
      setIsVisible(false);
      onComplete();
      return;
    }
    sessionStorage.setItem('mp_intro_seen', 'true');
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onComplete, 800); // Wait for exit animation
    }, 3000);
    return () => clearTimeout(timer);
  }, [onComplete]);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-404">
      <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeInOut'
    }} className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-brand-cream overflow-hidden" data-id="element-405">
        {/* Floating background elements */}
        {!reducedMotion && <>
            <motion.div initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: [0, 1.5, 2],
          opacity: [0, 0.1, 0]
        }} transition={{
          duration: 3,
          ease: 'easeOut'
        }} className="absolute w-[600px] h-[600px] rounded-full bg-brand-terracotta/20 blur-3xl pointer-events-none" data-id="element-406" />
            <motion.div initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: [0, 1.2, 1.5],
          opacity: [0, 0.15, 0]
        }} transition={{
          duration: 2.5,
          delay: 0.5,
          ease: 'easeOut'
        }} className="absolute w-[400px] h-[400px] rounded-full bg-brand-blue/30 blur-3xl pointer-events-none" data-id="element-407" />
          </>}

        {/* Scissors Animation */}
        <motion.div initial={{
        opacity: 0,
        y: 20,
        rotate: -20
      }} animate={{
        opacity: [0, 1, 0],
        y: [20, 0, -20],
        rotate: [-20, 0, 20]
      }} transition={{
        duration: 2,
        ease: 'easeInOut'
      }} className="mb-8 text-brand-terracotta" data-id="element-408">
          <Scissors size={48} strokeWidth={1.5} data-id="element-409" />
        </motion.div>

        {/* Logo */}
        <motion.img src={LOGO_URL} alt="Conexión Salon and Spa" initial={reducedMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        scale: 0.9
      }} animate={reducedMotion ? {
        opacity: 1
      } : {
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.5,
        ease: 'easeOut'
      }} className="h-24 md:h-32 w-auto object-contain z-10" data-id="element-410" />

        {/* Taglines */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.2
      }} className="mt-8 text-center z-10" data-id="element-411">
          <p className="font-serif text-2xl text-brand-brown tracking-wide mb-2" data-id="element-412">
            Salon and Spa · Chicago
          </p>
          <p className="text-brand-brown/60 tracking-widest uppercase text-xs" data-id="element-413">
            Connecting beauty with home
          </p>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}